import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppDynamicFilterModal from "../../partials/AppDynamicFilterModal";
import { Divider, Flex, Space } from "antd";

export class EmployeesSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      openDrawer: false,
    };
    this.fields = [
      // {
      //   name: "employee_id",
      //   label: "Employee ID",
      //   type: "text",
      // },
      {
        name: "full_name",
        label: "Employee Name",
        type: "text",
      },
      // {
      //   name: "mobile_number",
      //   label: "Mobile No.",
      //   type: "text",
      // },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.EMPLOYEE_STATUS,
      },
    ];
  }

  componentDidMount() {}

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    let { role } = this.props?.$store?.user | {};
    let fields;
    if (role === _enum.ROUTE_PERSONAS.manager) {
      fields = this.fields.filter((v) => v.name !== "designation");
    } else {
      fields = this.fields;
    }

    return (
      <div className="mb-3">
        <Flex gap="middle" align="center" justify="end" className="px-3">
          <Space size="small" split={<Divider type="vertical" />} wrap>
            <AppButton
              variant="excel"
              onClick={(e) => this.props.downloadExcel(e)}
            >
              Download Excel
            </AppButton>
            <button
              type="button"
              className="btn filter_modal_btn"
              onClick={(...args) => this.toggleDrawer(...args)}
            >
              <i class="fa-solid fa-filter me-2"></i>
              <span>Filters</span>
            </button>
            <Link
              to={"#"}
              className="btn btn-primary add_digi_team_member_btn bg_gradient"
              onClick={(...args) => this.props.onAddModalFields(...args)}
            >
              Add Employee
            </Link>
          </Space>
        </Flex>

        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(EmployeesSearch);
